import { SendNotificationBody } from "../../Constants/Interfaces/payloadInterface/SendNotification.interface";

interface ValidationData {
  message: string;
  isValid: boolean;
}
export const validateSendNotifications = ({
  title,
  text,
  audience_id,
  category,
}: SendNotificationBody): ValidationData => {
  const validationData: ValidationData = {
    message: "",
    isValid: true,
  };
  if (!title) {
    validationData.message = "Title is required";
    validationData.isValid = false;
  }

  if (!text) {
    validationData.message = "Body is required";
    validationData.isValid = false;
  }

  if (!audience_id) {
    validationData.message = "Audience is required";
    validationData.isValid = false;
  }

  if (!category) {
    validationData.message = "Category is required";
    validationData.isValid = false;
  }

  return validationData;
};
